import React from 'react';
import { Box } from 'native-base';
import { LoanOverview } from '../../../components';
import { selectLoanScheduledClosingDate, useLoanOverviewQuery, useLoanStatusQuery } from '../../../hooks';
import LoanOverviewSkeleton from '../../../components/NewLoanInProgress/LoanOverviewSkeleton';
const LoanOverviewContainer = props => {
  return /*#__PURE__*/React.createElement(Container, props);
};
const Container = props => {
  const {
    url,
    accessToken,
    logApiEvent,
    loanNumber,
    isEnabled
  } = props;
  const {
    isSuccess,
    isLoading,
    data
  } = useLoanOverviewQuery({
    accessToken,
    url,
    logApiEvent,
    loanNumber
  });
  const {
    isSuccess: loanStatusIsSuccess,
    data: closingDate
  } = useLoanStatusQuery({
    accessToken,
    url,
    logApiEvent,
    loanNumber,
    select: statusData => selectLoanScheduledClosingDate(statusData),
    enabled: isEnabled
  });
  if (isLoading) return /*#__PURE__*/React.createElement(LoanOverviewSkeleton, {
    dataTestID: 'loan-overview-skeleton'
  });
  return isSuccess && data ? /*#__PURE__*/React.createElement(LoanOverview, {
    loanOverviewData: data.responseDetails,
    closingDate: loanStatusIsSuccess && closingDate ? closingDate : '',
    statusCode: props.statusCode
  }) : /*#__PURE__*/React.createElement(Box, {
    testID: "loan-overview-error-box"
  });
};
export default /*#__PURE__*/React.memo(LoanOverviewContainer);
//# sourceMappingURL=index.js.map